<template>
  <div class="v-badge">
    <div v-if="source.type==='channel'" class="mr-2 vselect_container mb-4">
      <div>
        <span class="multi_title" style="font-size: 14px"
          >{{ source.name }}
        </span>
        <font-awesome-icon
          style="color: black; cursor:pointer"
          @click="$emit('remove')"
          icon="times"
        />
      </div>
      <v-select
        v-if="!!source.measures"
        autowidth
        v-model="selectedOptions"
        :clearable="false"
        class="style-chooser-vselect"
        :placeholder="'Select'"
        :multiple="true"
        :options="measureTypes(source.code)"
        label="name"
      >
      </v-select>
    </div>
    <b-badge v-else class="mb-4" id="badgeFont">
      <span>
        {{ source.name }}
        <font-awesome-icon
          style="color: white; cursor:pointer"
          @click="$emit('remove')"
          icon="times"
        />
        <!-- <a class="remove-item-link" @click="$emit('remove')">x</a> -->
      </span>
    </b-badge>

    <div v-if="showOptions" class="v-badge__options">
      <div
        class="v-badge__option"
        v-for="option in measureTypes"
        :key="option.key"
        @click="onSelect(option)"
      >
        <div
          class="v-badge__option-checkbox"
          :class="{
            'v-badge__option-checkbox_selected': selectedTypes.find(
              (type) => type === option.key
            ),
          }"
        ></div>
        <div class="v-badge__option-title">
          {{ option.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "VBadge",
  components: {
    vSelect,
  },

  props: {
    source: {
      required: true,
    },

    badgeType: {
      type: String,
      required: false,
      default: "channels",
    },
  },

  watch:{
    //FUNCTION: sets measures for selected source each time measures are changed
    selectedOptions(val, oldVal){
      if(oldVal === null) return
      if(val.length === 0) this.$emit('remove')
      else this.setMeasuresInSelectedSource({source:this.source, measures:val.map(o=>o.key)})

    }
  },

  data() {
    return {
      isEnergia: true,
      componentCreated: false,
      showOptions: false,
      selectedOptions: null,
    };
  },

  mounted() {
    if(!this.source.measures || !this.channelMeasureEntity) return;
    let sourceMT = this.channelMeasureEntity.measureTypes;
    this.selectedOptions = this.source.measures.map(m=>({key:m, name:sourceMT[m]}))
  },

  computed: {
    ...mapState({
      sites: (state) => state.user.sites,
      stateSelectedMeasureTypes: (state) => {
        return state.charts.selectedMeasureTypes;
      },
    }),

    ...mapGetters({
      getMeasureTypeByCode: "charts/getMeasureTypeByCode",
      availableMeasureTypes: "charts/measureTypes",
    }),

    channelMeasureEntity() {
      return this.getMeasureTypeByCode(this.source.code);
    },

    isExistsAnyMeasureTypes() {
      return Array.isArray(this.measureTypes()) && this.measureTypes.length > 1;
    },
  },

  methods: {
    ...mapActions({
      setMeasuresInSelectedSource: 'charts/setMeasuresInSelectedSource',
      toggleStateSelectedMeasureType: "charts/toggleSelectedMeasureType",
    }),

    toggleOptions() {
      this.showOptions = !this.showOptions;
    },

    setMeasure(option) {
      this.toggleMeasureInSelectedSource({source: this.source, measure:option.key})
    },

    measureTypes(code) {
      let measures = [];
      let channel = {};
      this.$store.state.user.sites.forEach(site => {
        site.channels.forEach(item => {
          if(item.code == code) {
            channel = item;
          }
        })
      })   
      
      if(channel && channel.measure_types && channel.measure_types.length > 0) {
        channel.measure_types.forEach(item => {
          this.measureTypes().forEach(mt => {
            if(mt.key == item) {
              measures.push({ key: mt.key, name: mt.name });
            }
          })
        })
      } else {
        let MT = this.getMeasureTypeByCode(this.source.code);
        if(!MT) return [];
        measures = Object.keys(MT.measureTypes)
          .map(k => ({key:k,name:MT.measureTypes[k]}));
      }
      
      let priorityMeasures = {
        "Energia": 1,
        "Energia Reattiva": 2,
        "Fattore di Potenza equivalente": 3,
        "Tensione concatenata equivalente": 4,
        "Corrente equivalente": 5
      }
      
      const maxPriority = 100;

      measures = measures.sort((a, b) => {
        const weightA = priorityMeasures[a.name] ? priorityMeasures[a.name] : maxPriority;
        const weightB = priorityMeasures[b.name] ? priorityMeasures[b.name] : maxPriority;

        if(weightA == maxPriority && weightB == maxPriority) {
          return a.name < b.name ? -1 : 1;
        }
        return weightA < weightB ? -1 : 1;
      })

      return measures;
    },

    getName(entity) {
      let name = null;

      switch (this.badgeType) {
        case "indicators":
          name = entity.formula ? entity.formula.name : "";
          break;
        case "channels":
          name = entity.name ? entity.name : "";
          break;
      }

      return name;
    },

    compareEntityCode(entity) {
      let result = null;

      switch (this.badgeType) {
        case "indicators":
          result = entity.id === this.source.code;
          break;
        case "channels":
          result = entity.code === this.source.code;
          break;
      }

      return result;
    },
  },
};
</script>

<style>
.v-badge {
  position: relative;
}

.v-badge__toggle-block {
  cursor: pointer;
  margin-right: 5px;
}

.v-badge__toggle {
  margin-left: 5px;
}

.v-badge__options {
  position: absolute;
  top: calc(100% - 3px);
  left: 0;
  right: 6px;
  min-width: 200px;
  max-height: 250px;
  overflow-y: auto;
  z-index: 100;
  padding: 5px 10px;
  color: #fff;
  background-color: #6c757d;
}

.v-badge__option {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.v-badge__option:last-child {
  margin-bottom: 0;
}

.v-badge__option-title {
  font-size: 11px;
}

.v-badge__option-checkbox {
  margin-right: 5px;
  width: 10px;
  height: 10px;
  border: 1px solid #fff;
  position: relative;
}

.v-badge__option-checkbox_selected:after {
  position: absolute;
  left: 2px;
  top: -1px;
  transform: rotate(45deg);
  border: 1px solid #fff;
  border-left: none;
  border-top: none;
  content: "";
  width: 4px;
  height: 8px;
}
.multi_title {
  color: black !important;
  font-weight: 600;
  text-decoration: none !important;
}
.vselect_container input {
  width: 65px !important;
}
.style-chooser-vselect .vs__dropdown-menu {
  /* min-width: auto !important; */
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/VBadge.vue